import { apiService } from '../../../services/api';

export interface ConsentState {
  consented: boolean;
  consented_at: string | null;
  withdrawn_at: string | null;
  sharepoint_url: string | null;
}

class ConsentService {

  async getConsent(): Promise<ConsentState> {
    return await apiService.get('/api/contractor-profile/consent');
  }

  async giveConsent(pdfFile: File, filename: string, profilePhoto: string | null): Promise<ConsentState> {
    const formData = new FormData();
    formData.append('file', pdfFile);
    formData.append('filename', filename);
    if (profilePhoto) {
      formData.append('profile_photo', profilePhoto);
    }

    const response = await apiService.getInstance().post('/api/contractor-profile/consent', formData);
    return response.data;
  }

  async withdrawConsent(): Promise<ConsentState> {
    const response = await apiService.getInstance().delete('/api/contractor-profile/consent');
    return response.data;
  }
}

export const consentService = new ConsentService();
